import db from '../db.json';
import { useEffect, useState } from 'react';

import Window from "../Components/Window";

let bodyStyle = {
    backgroundImage: `url(/doujinarchive/img/windowbg.jpg)`,
    backgroundRepeat: `no-repeat`
};

db.sort((a, b) => {
    if(a.title > b.title) {
      return 1;
    }
  
    if(a.title < b.title) {
      return -1;
    }
  
    return 0;
});

export default function Archive(props) {
    let [memDB, setMemDB] = useState([]);

  let sortByTitle = () => {
    db.sort((a, b) => {
      if(a.title > b.title) {
        return 1;
      }
    
      if(a.title < b.title) {
        return -1;
      }
    
      return 0;
    });

    setMemDB([...db]);
  }

  let sortByCircle = () => {
    db.sort((a, b) => {
      if(a.circle > b.circle) {
        return 1;
      }
    
      if(a.circle < b.circle) {
        return -1;
      }
    
      if(a.circle === b.circle) {
        if(a.title > b.title) {
          return 1;
        }
      
        if(a.title < b.title) {
          return -1;
        }
      }

      return 0;
    });

    setMemDB([...db]);
  }

  let sortByYear = () => {
    db.sort((a, b) => {
      if(a.year > b.year) {
        return 1;
      }
    
      if(a.year < b.year) {
        return -1;
      }
    
      if(a.year === b.year) {
        if(a.title > b.title) {
          return 1;
        }
      
        if(a.title < b.title) {
          return -1;
        }
      }

      return 0;
    });

    setMemDB([...db]);
  }

  useEffect(() => {
    setMemDB([...db]);
  }, []);

    return(
        <div>
        <div className="window">
            <div className="window-title">
                <img alt="window icon" src={`/doujinarchive/ico/AYUFUSI.png`} className="window-icon"/>
                Important Information
            </div>
            <div className="window-body" style={bodyStyle}>
                <table className="header-table">
                    <tr className="header-row">
                        <td>
                            <img alt="cover art" className="cover-art" src={`/doujinarchive/img/Info.png`}/>
                        </td>
                        <td className="game-info">
                            <h2>Please Read</h2>
                            <h6 className="maker">Billy, 2024</h6>
                            <p className="description">Any software linked to by this website was created by doujin circles that are either not active anymore or at least not actively selling the software in question. Software linked to by this site is purely for archival and educational purposes.</p>
                            <p>I will happily remove links to any software upon the author's request. Please contact me <a href="mailto:btuberbilly@gmail.com">here</a> to request a takedown.</p>
                        </td>
                    </tr>
                </table>
                <div className="controls">
                    <button onClick={sortByTitle}>Sort by Title</button>
                    <button onClick={sortByCircle}>Sort by Circle</button>
                    <button onClick={sortByYear}>Sort by Year</button>
                    <button onClick={() => {props.chng('Blog')}}>Blog</button>
                </div>
            </div>
        </div>
      
      {memDB.map(game => {
        return(
          <Window game={game}/>
        );
      })}

<div className="window description">
            <div className="window-title">
                <img alt="window icon" src={`/doujinarchive/ico/MeltyBloodFRB.png`} className="window-icon"/>
                Tips & General Fixes
            </div>
            <div className="window-body" style={bodyStyle}>
                <table className="header-table">
                    <tr className="header-row">
                        <td>
                            <img alt="cover art" className="cover-art" src={`/doujinarchive/img/CielSensei.png`}/>
                        </td>
                        <td className="game-info">
                          <p className='description'> </p>
                            <h2 className='description'>Teach me, Ciel-sensei!</h2>
                            <h4>Locale</h4>
                            <p className="description">When attempting to launch or install any of these games, I always use a Japanese locale. This should be the first thing you attempt to change if you run into any issues. You can easily change your whole Windows locale to Japanese, but you can also usually get away with using utilities like <a href="https://xupefei.github.io/Locale-Emulator/">Xupefei's Locale Emulator</a> for most things.</p>
                            <h4>No window, but process is running</h4>
                            <p className="description">I usually encounter this one for mid-00's doujinsoft. It's usually because the installer is erroneously waiting for a process to finish executing. To can get around this, launch Task Manager, find the appropriate process (ie "32 bit setup installer" or something like that) and right click it, click Details, right click the process again, click Analyze Wait Chain, and end any processes it's waiting on. </p>
                            <h4>Windowed Mode</h4>
                            <p className="description">Sometimes, you may find that the "Windowed Mode" option is greyed out for a game. This is usually because the game can only run in Windowed mode @ 16-bit color depth. To fix this, right click on the application and navigate to Properties - Compatibility and make sure Reduced Color Mode is checked + 16 bit mode is selected in the drop down list.</p>
                            <h4>Game runs extremely slowly</h4>
                            <p className="description">This one can be tricky since a few things can be the culprit. Firstly, I'd play the game in Windowed mode if possible. If that doesn't fix the issue, then you try setting CPU Affinity to a single core by navigating to the same "Details" screen in Task Manager, right clicking the application, and selecting the "Set Affinity" option. Make sure only a single core is selected and apply the change.</p>
                            <h4>Steam Deck</h4>
                            <p className='description'>Most of these games run fine on Deck. Some have a few issues like music not playing in POTATOHAZARD. Some don't work at all no matter what I try. Getting these games running on Deck deserves a whole writeup of its own so I won't go into detail here. My honest recommendation is to just try something; if it doesn't work or play the way you want to on Deck and you have the time to tinker, then tinker around with it.</p>
                            <h4>Floppy Disks</h4>
                            <p className='description'>For floppies, I create a .DSK image file using <a href="http://www.lexlechz.at/en/software.html">Lex Lechz's Disk-Manager software</a>. You can use this same software to rewrite the image to a new disk.</p>
                        </td>
                    </tr>
                </table>
            </div>
        </div>
        </div>
    );
}